<template>
  <v-menu
    location="end"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ props }">
      <v-avatar
          :color="modelValue"
          v-bind="props"
          class="avatar-border clickable"
          :class="{'mr-3': label}"
      />
      <v-label v-if="label">{{ label }}</v-label>
    </template>
    <v-color-picker
        :modes="['hexa']"
        :model-value="modelValue"
        @update:modelValue="emit('update:modelValue', $event)"
    />
  </v-menu>
</template>

<script setup>
defineProps({
  modelValue: String,
  label: String,
});

const emit = defineEmits(['update:modelValue']);
</script>

<style scoped>
.avatar-border {
  border-style: solid;
  border-width: 3px;
  border-color: rgb(144, 144, 144);
}
</style>
<style>
.v-text-field input {
  opacity: 1;
  margin-right: 15px;
  cursor: unset;
}
</style>
